export const BM_FINANCES_GET = "bmFinancesGet"
export const BM_FINANCE_SEARCH = "bmFinanceSearch"
export const BM_FINANCE_GET = "bmFinanceGet"